import { NgModule } from '@angular/core';
import { UrlModule } from 'haba-core';
import { BaseStorefrontModule } from 'haba-storefrontlib';

import { SpartacusFeaturesModule } from './spartacus-features.module';
import { SpartacusConfigurationModule } from './spartacus-configuration.module';

@NgModule({
  declarations: [],
  imports: [BaseStorefrontModule, SpartacusFeaturesModule, SpartacusConfigurationModule],
  exports: [
    BaseStorefrontModule,
    UrlModule, // We need this for all components, that currently don't have an own module, like footer
  ],
})
export class SpartacusModule {}
